import React from 'react';
import { DataTable } from '@/library/DataTable';
import { ColumnDef } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { BsWrench } from 'react-icons/bs';

type DateList = {
  [key: string]: any[];
};

type IssueTableProps = {
  warnings: DateList;
  errors: DateList;
};

export const IssueTable = ({ warnings, errors }: IssueTableProps) => {
  const { t } = useTranslation();

  const columns: ColumnDef<any>[] = [
    {
      accessorKey: 'type',
      header: t('general.table_headers.name'),
      cell: ({ row }) => {
        const type = row.getValue('type');
        return (
          <div className="py-2">
            {type === 'warning' ? (
              <span className="flex gap-2 items-center text-orange-400">
                {t('general.warning')}
              </span>
            ) : (
              <div className="flex gap-2 items-center text-red-400">{t('general.error')}</div>
            )}
          </div>
        );
      },
    },
    {
      accessorKey: 'user',
      header: t('general.table_headers.name'),
      cell: ({ row }) => <div className="py-2">{row.getValue('user')}</div>,
    },
    {
      accessorKey: 'message',
      header: t('general.table_headers.error'),
      cell: ({ row }) => (
        <div className="py-2">{t('time_tracking.issue.' + row.getValue('message'))}</div>
      ),
    },
  ].filter(Boolean);

  return (
    <div>
      {(warnings !== undefined || errors !== undefined) && (
        <div className="my-4">
          <h2 className="text-lg mx-8 font-semibold mb-2">
            <div
              className={
                'bg-gray-400 mr-2 text-white rounded-full space-x-1 px-1.5 py-0.5 lg:px-2 lg:py-1 inline-flex items-center justify-center'
              }
            >
              <BsWrench size={17} />
            </div>
            {t('general.hints')}
          </h2>
          <DataTable
            data={Object.values({ ...warnings, ...errors })}
            columns={columns}
            disableSearch
            disableColumnSelector
          />
        </div>
      )}
    </div>
  );
};
